/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateExportTargetMappingDataSchema = z.object({
	syncDisqualifiedCandidates: z.boolean(),
})

export type UpdateExportTargetMappingDataSchema = z.infer<typeof updateExportTargetMappingDataSchema>
